import axios from 'axios'
import {
  GET_MESSAGING_USERS_REQUEST,
  GET_MESSAGING_USERS_SUCCESS,
  GET_MESSAGING_USERS_FAIL,
  SEND_DIRECT_MESSAGE_REQUEST,
  SEND_DIRECT_MESSAGE_SUCCESS,
  SEND_DIRECT_MESSAGE_FAIL,
  GET_MESSAGE_TEMPLATES_REQUEST,
  GET_MESSAGE_TEMPLATES_SUCCESS,
  GET_MESSAGE_TEMPLATES_FAIL,
  GET_USER_MESSAGE_HISTORY_REQUEST,
  GET_USER_MESSAGE_HISTORY_SUCCESS,
  GET_USER_MESSAGE_HISTORY_FAIL,
  CLAIM_VOUCHER_REQUEST,
  CLAIM_VOUCHER_SUCCESS,
  CLAIM_VOUCHER_FAIL,
  GET_VOUCHER_STATUS_REQUEST,
  GET_VOUCHER_STATUS_SUCCESS,
  GET_VOUCHER_STATUS_FAIL,
  GET_MY_VOUCHERS_REQUEST,
  GET_MY_VOUCHERS_SUCCESS,
  GET_MY_VOUCHERS_FAIL,
} from '../constants/messagingConstants'

const baseUrl = process.env.REACT_APP_API_URL

// ===========================
// Simplified Messaging Actions
// ===========================

// Get users for direct messaging
export const getMessagingUsers = (filters = {}) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_MESSAGING_USERS_REQUEST,
    })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    let url = `${baseUrl}/messaging/users`
    const params = []

    if (filters.verification && filters.verification !== 'all') params.push(`verification=${filters.verification}`)
    if (filters.clubId && filters.clubId !== 'all') params.push(`clubId=${filters.clubId}`)
    if (filters.activity && filters.activity !== 'all') params.push(`activity=${filters.activity}`)
    if (filters.minWalletBalance && filters.minWalletBalance !== 'all') params.push(`minWalletBalance=${filters.minWalletBalance}`)
    if (filters.search && filters.search.trim()) params.push(`search=${encodeURIComponent(filters.search.trim())}`)

    if (params.length > 0) url += `?${params.join('&')}`

    const { data } = await axios.get(url, config)

    dispatch({
      type: GET_MESSAGING_USERS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_MESSAGING_USERS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// Get message templates for dropdown
export const getMessageTemplates = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_MESSAGE_TEMPLATES_REQUEST,
    })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`${baseUrl}/messaging/templates-list`, config)

    dispatch({
      type: GET_MESSAGE_TEMPLATES_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_MESSAGE_TEMPLATES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// Get user message history
export const getUserMessageHistory = (userId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_USER_MESSAGE_HISTORY_REQUEST,
    })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`${baseUrl}/messaging/users/${userId}/history`, config)

    dispatch({
      type: GET_USER_MESSAGE_HISTORY_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_USER_MESSAGE_HISTORY_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}


// Send direct message
export const sendDirectMessage = (userIds, message, channel) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SEND_DIRECT_MESSAGE_REQUEST,
    })

    const {
      adminLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(
      `${baseUrl}/messaging/send`,
      { userIds, message, channel },
      config
    )

    dispatch({
      type: SEND_DIRECT_MESSAGE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: SEND_DIRECT_MESSAGE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// ===========================
// Voucher Actions
// ===========================

// Claim voucher
export const claimVoucher = (code) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CLAIM_VOUCHER_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(`${baseUrl}/messaging/vouchers/claim`, { code }, config)

    dispatch({
      type: CLAIM_VOUCHER_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: CLAIM_VOUCHER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// Get voucher status
export const getVoucherStatus = (code) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_VOUCHER_STATUS_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`${baseUrl}/messaging/vouchers/${code}/status`, config)

    dispatch({
      type: GET_VOUCHER_STATUS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_VOUCHER_STATUS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// Get my vouchers
export const getMyVouchers = (status = '', page = 1, limit = 20) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_MY_VOUCHERS_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    let url = `${baseUrl}/messaging/vouchers/my?page=${page}&limit=${limit}`
    if (status) url += `&status=${status}`

    const { data } = await axios.get(url, config)

    dispatch({
      type: GET_MY_VOUCHERS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_MY_VOUCHERS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}
